import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import AddServiceProviderIndex from "../../../components/SidetabPages/ServiceProvider/AddEditForm";

const AddServiceProvider = () => {
  return (
    <>
      <AnnouncementBar />
      <AddServiceProviderIndex />
    </>
  );
};
export default AddServiceProvider;
